
import Toast from 'vue-toastification'
import { createToastInterface } from 'vue-toastification'

import '@/assets/scss/vue/libs/toastification.scss';

const pluginsOptions = {
  hideProgressBar: false,
  closeOnClick: false,
  closeButton: false,
  icon: false,
  timeout: 3000,
  transition: 'Vue-Toastification__fade',
  position:'bottom-right'
  
};

window.toast = createToastInterface(pluginsOptions)
const app = createApp({})
app.use(Toast, pluginsOptions)

  